/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useEffect, useState } from 'react';
import {
  useSelector,
  useDispatch,
} from 'react-redux';
import {
  AppBar,
  Container,
  Toolbar,
  IconButton,
  Box,
  Grid,
  Hidden,
  withStyles,
} from '@material-ui/core';
import { Search, Close } from '@material-ui/icons';
import { Formik, Field } from 'formik';
import theme from 'theme';
import { useHistory } from 'react-router-dom';
import {
  toggleDrawer,
  setDrawer,
  drawerSelector,
} from 'slices/drawer';
import { toggleContact, contactSelector } from 'slices/contact';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFlip } from 'swiper';
import { DRAWER_MENU } from 'App/constants';
import Link from 'App/components/Link';
import Translator from 'App/components/Translator';
import MenuIcon from './components/MenuIcon';
import ElevationScroll from './components/ElevationScroll';
import RightMenu from './components/RightMenu';
import HeaderMenu from './components/HeaderMenu';
import ContactUsDialog from './components/ContactUsDialog';
import SearchBar from '../SearchBar';
import DownloadCatalogue from './components/DownloadCatalogue';

const Header = withStyles(() => ({
  blueBar: {
    paddingTop: theme.spacing(1.3),
    background: theme.palette.primary.main,
    height: 40,
    fontSize: 14,
    color: theme.palette.common.white,
  },
  marginBar: {
    [theme.breakpoints.up('md')]: {
      minHeight: 144,
    },
  },
  appBar: {
    [theme.breakpoints.up('md')]: {
      height: theme.spacing(18),
    },
    [theme.breakpoints.down('sm')]: {
      zIndex: theme.zIndex.modal + 1,
    },
  },
  navBar: {
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(1),
    },
  },
  logo: {
    height: theme.spacing(5),
    [theme.breakpoints.up('md')]: {
      height: theme.spacing(8),
      marginTop: theme.spacing(1.5),
    },
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(-0.5),
    outline: 'none',
  },
  subLogoContainer: {
    height: theme.spacing(7),
    width: theme.spacing(7),
    marginLeft: theme.spacing(1),
    display: 'inline-block',
    '& input': {
      height: theme.spacing(7),
      width: theme.spacing(7),
      background: 'white',
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(1.5),
      height: theme.spacing(5),
      width: theme.spacing(5),
      '& input': {
        height: theme.spacing(5),
        width: theme.spacing(5),
      },
    },
    outline: 'none',
  },
  smartKhetiLogo: {
    width: theme.spacing(17),
    marginBottom: theme.spacing(2.5),
    marginLeft: theme.spacing(1.5),
    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(1.5),
      width: theme.spacing(11),
      marginBottom: theme.spacing(1.75),
    },
  },
}))(({ classes, location }) => {
  const history = useHistory();
  const [searchOpen, setSearchOpen] = useState(false);
  const drawer = useSelector(drawerSelector);
  const contact = useSelector(contactSelector);
  const dispatch = useDispatch();
  const toggleContactUsDialog = useCallback(() => dispatch(toggleContact()), [dispatch]);
  const toggleContactUs = useCallback(() => {
    const willDialogOpen = !contact;

    history.replace(willDialogOpen ? '?c' : '');
    toggleContactUsDialog();
  }, [contact, history, toggleContactUsDialog]);
  const handleSelect = (value) => history.push(`/products/${encodeURIComponent(value.id)}`);

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    if (params.has('c') && !contact) {
      toggleContactUsDialog();
    }
  }, [toggleContactUsDialog, location.search, contact]);

  return (
    <Formik initialValues={{ search: '' }} onSubmit={() => { }}>
      <>
        <ContactUsDialog open={contact} onClose={toggleContactUs} />
        <ElevationScroll forceElevate={drawer}>
          <AppBar color="inherit" className={classes.appBar}>
            <Hidden smDown>
              <div className={classes.blueBar}>
                <Container>
                  <Grid container spacing={6} justify="flex-end">
                    <Grid item>
                      <Link to="/careers">
                        Careers
                      </Link>
                    </Grid>
                    <Grid item>
                      <Link to="/corporate">
                        Corporate
                      </Link>
                    </Grid>
                    <Grid item>
                      <Link to="/about/who-we-are">
                        About Us
                      </Link>
                    </Grid>
                    <Grid item>
                      <Box mt={-1}>
                        <Field
                          name="search"
                          component={SearchBar}
                          handleSelect={handleSelect}
                        />
                      </Box>
                    </Grid>
                    <Box mt={2.625}><Translator inline /></Box>
                    <Grid item>
                      <DownloadCatalogue />
                    </Grid>
                  </Grid>
                </Container>
              </div>
            </Hidden>
            <Container disableGutters className={classes.navBar}>
              <Toolbar style={{ position: 'relative' }}>
                <Box flexGrow="1" whiteSpace="nowrap">
                  <Link to="/">
                    <input
                      type="image"
                      draggable="false"
                      src={`${process.env.PUBLIC_URL}/images/logo.gif`}
                      alt="INVAS"
                      className={classes.logo}
                      style={{ position: 'relative', zIndex: searchOpen ? 2 : 'auto' }}
                    />
                  </Link>
                  <Link to="/">
                    <Swiper
                      loop
                      autoplay
                      effect="flip"
                      allowTouchMove={false}
                      modules={[Autoplay, EffectFlip]}
                      flipEffect={{ slideShadows: false }}
                      className={classes.subLogoContainer}
                    >
                      <SwiperSlide>
                        <input type="image" draggable="false" src={`${process.env.PUBLIC_URL}/images/20-anniv.png`} alt="20th Anniversary" />
                      </SwiperSlide>
                      <SwiperSlide>
                        <input type="image" draggable="false" src={`${process.env.PUBLIC_URL}/images/tsdsi.png`} alt="TSDSI Corporate Member" />
                      </SwiperSlide>
                    </Swiper>
                  </Link>
                  <Link href="https://smartkheti.co.in" target="_blank" rel="noopener noreferrer">
                    <img draggable="false" src={`${process.env.PUBLIC_URL}/images/smartkheti-clr.png`} alt="SmartKheti" className={classes.smartKhetiLogo} />
                  </Link>
                </Box>
                <Hidden smDown>
                  {/*
                    "About Us" is already in the blue bar on the desktop view,
                    so we filter it out from the main menu to avoid duplication.
                  */}
                  <HeaderMenu
                    toggleContactUs={toggleContactUs}
                    items={DRAWER_MENU.filter((item) => !item.isAbout)}
                  />
                </Hidden>
                <Hidden mdUp>
                  {searchOpen && (
                    <Box position="absolute" top={0} left={0} bottom={0} right={0} bgcolor="background.paper" display="flex" alignItems="center" justifyContent="flex-end" pl={18} pr={11} zIndex={1}>
                      <Field
                        name="search"
                        component={SearchBar}
                        handleSelect={handleSelect}
                      />
                    </Box>
                  )}
                  <IconButton onClick={() => setSearchOpen(!searchOpen)} color="primary" style={{ marginRight: -12, position: 'relative', zIndex: 2 }}>
                    {searchOpen ? <Close /> : <Search />}
                  </IconButton>
                  <IconButton edge="end" onClick={() => dispatch(toggleDrawer(!drawer))} style={{ position: 'relative', zIndex: 2 }}>
                    <MenuIcon isOpen={drawer} />
                  </IconButton>
                </Hidden>
              </Toolbar>
            </Container>
          </AppBar>
        </ElevationScroll>
        <Toolbar className={classes.marginBar} />
        <Hidden mdUp>
          <RightMenu
            isOpen={drawer}
            items={DRAWER_MENU}
            toggleContactUs={toggleContactUs}
            handleOpen={() => dispatch(setDrawer(true))}
            handleClose={() => dispatch(setDrawer(false))}
          />
        </Hidden>
      </>
    </Formik>
  );
});

export default Header;
